import React, { useCallback, useMemo, useState } from "react";
import Flx from "../layout/Flx";
import FileChip from "../chips/FileChip";
import FilePreviewSideModal from "../modals/FilePreviewSideModal";
import { isEmpty, isNil } from "lodash";
import Txt from "../typography/Txt";

const DocumentIdsRenderer = ({
  documents,
  documentIds,
  color,
  sx,
  chipSx,
  emptyLabelFontSize,
}) => {
  const [file, setFile] = useState(null);
  // const filteredFiles = documents?.filter((doc) =>
  //   documentIds?.includes(doc?._id),
  // );

  const filteredFiles = useMemo(() => {
    // No id filter provided → show everything that was passed in.
    if (isNil(documentIds)) return documents;
    // Otherwise show ONLY the matching documents. Do NOT fall back to all
    // documents when nothing matches — that surfaces unrelated loan documents
    // on a condition/comment that has no (resolvable) attachments.
    return documents?.filter((doc) => documentIds?.includes(doc?._id));
  }, [documents, documentIds]);

  const onPreviewFile = useCallback((file) => {
    setFile(file);
  }, []);

  if (isEmpty(filteredFiles))
    return <Txt fontSize={emptyLabelFontSize}>No documents available.</Txt>;
  return (
    <>
      <Flx wrap g={1} sx={sx}>
        {filteredFiles?.map((file) => (
          <FileChip
            key={file._id}
            file={file}
            onPreview={onPreviewFile}
            color={color}
            sx={chipSx}
          />
        ))}
      </Flx>
      <FilePreviewSideModal file={file} onClose={() => setFile(null)} />
      {/* <FilePreviewSideCardModal file={file} onClose={() => setFile(null)} /> */}
    </>
  );
};

export default DocumentIdsRenderer;
